// extracted by mini-css-extract-plugin
module.exports = {"payment":"PaymentPage_payment__Krd6S","container":"PaymentPage_container__mePlk","addParts":"PaymentPage_addParts__iaKcO"};